import React, { useState, useRef } from 'react';
import useWindowDimensions from '../hooks/useWindowDimensions';
import { BiChevronLeftCircle, BiChevronRightCircle } from "react-icons/bi";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

function Highlights({showTheOverlay}) {
    const { width } = useWindowDimensions();
    const isDesktop = width >= 1025;
    const isTablet = width >= 768 && width <= 1024;
    const isMobile = width <= 767;
  
    const styles = {
      buttonContainer: {
          // backgroundColor: 'red',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItms: 'center',
          fontSize: '30px',
          margin: '0px 5px 0px 0px'
      },
      icon: {
          cursor: 'pointer',
          color: '#c5c5c5'
      },
    };
  
    const scrollRef = useRef(null);
    
    const scrollLeft = () => {
        if (scrollRef.current) {
            const { scrollLeft } = scrollRef.current;
            if (scrollLeft > 0) {  // Only scroll if not already at the start
                scrollRef.current.scrollBy({ left: -200, behavior: 'smooth' });
            }
        }
    };
    
    const scrollRight = () => {
        if (scrollRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
            const maxScroll = scrollWidth - clientWidth;
    
            if (scrollLeft < maxScroll) {  // Only scroll if not already at the end
                scrollRef.current.scrollBy({ left: 200, behavior: 'smooth' });
            }
        }
    };
  
    const cards = [
        { videoId: 'NxXENH1r1Xc', videoUrl: 'https://www.youtube.com/shorts/NxXENH1r1Xc' },
        { videoId: '5RzEcanl7CY', videoUrl: 'https://www.youtube.com/shorts/5RzEcanl7CY' },
        { videoId: 'J7JEw9q0ZM8', videoUrl: 'https://www.youtube.com/shorts/J7JEw9q0ZM8' },
        { videoId: 'eDAP3VPnCTY', videoUrl: 'https://www.youtube.com/shorts/eDAP3VPnCTY' },
        { videoId: 'yBovl5XcxVg', videoUrl: 'https://www.youtube.com/shorts/yBovl5XcxVg' },
        { videoId: 'C_8AXRz8nJE', videoUrl: 'https://www.youtube.com/shorts/C_8AXRz8nJE' },
        { videoId: 'VwidHJSE6o4', videoUrl: 'https://www.youtube.com/shorts/VwidHJSE6o4' },
        { videoId: '5-d7-zQliCA', videoUrl: 'https://www.youtube.com/shorts/5-d7-zQliCA' },
        { videoId: '-PuRuzZyt48', videoUrl: 'https://www.youtube.com/shorts/-PuRuzZyt48' },
        { videoId: 'rXEXXhV67l8', videoUrl: 'https://www.youtube.com/shorts/rXEXXhV67l8' },
        { videoId: 'zisTfUuh9Cs', videoUrl: 'https://www.youtube.com/shorts/zisTfUuh9Cs' },
        { videoId: 'v2c5FRU4rzs', videoUrl: 'https://www.youtube.com/shorts/v2c5FRU4rzs' },
        { videoId: 'G9_ptCYu_fQ', videoUrl: 'https://www.youtube.com/shorts/G9_ptCYu_fQ' },
        { videoId: 'HpiIG0jtKZs', videoUrl: 'https://www.youtube.com/shorts/HpiIG0jtKZs' },
        { videoId: 'NJutH2TxtKA', videoUrl: 'https://www.youtube.com/shorts/NJutH2TxtKA' },
        { videoId: '6zbaDLl1M_c', videoUrl: 'https://www.youtube.com/shorts/6zbaDLl1M_c' },
        { videoId: 'reJXp-_l_lE', videoUrl: 'https://www.youtube.com/shorts/reJXp-_l_lE' },
        { videoId: 'bAQtqFcQPbY', videoUrl: 'https://www.youtube.com/shorts/bAQtqFcQPbY' },
        { videoId: 'vpeDqTcR-Qw', videoUrl: 'https://www.youtube.com/shorts/vpeDqTcR-Qw' },
        { videoId: 'bVuMO4cmmzs', videoUrl: 'https://www.youtube.com/shorts/bVuMO4cmmzs' },
        { videoId: 'Loryw3jP8Ks', videoUrl: 'https://www.youtube.com/shorts/Loryw3jP8Ks' },
        { videoId: 'gN88D_2zftA', videoUrl: 'https://www.youtube.com/shorts/gN88D_2zftA' },
    ];
  
    function reValue({ desktop, tablet, mobile }) {
        if (isDesktop) {
            return desktop;
        }
        if (isTablet) {
            return tablet;
        }
        if (isMobile) {
            return mobile;
        }
    }
  
    // State to handle hover effect
    const [hoveredCard, setHoveredCard] = useState(null);
  
    return (
      <div style={reValue({
        desktop: { display: 'flex', flexDirection: 'column', justifyContent: 'start', alignItems: 'center', width: '100vw', height: 'fitContent', margin: '0px 0px 0px 0px'},
        tablet: { display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "center", width: "100vw", height: "fit-content", margin: "0px 0px 0px 0px" },
        mobile: { display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "center", width: "100vw", height: "fit-content", margin: "0px 0px 0px 0px" }
      })}>
        <div style={reValue({
          desktop: { display: "flex", flexDirection: "row", width: "90%", justifyContent: "space-between", alignItems: "start", height: "fit-content" },
          tablet: { display: "flex", flexDirection: "row", width: "80%", justifyContent: "space-between", alignItems: "start", height: "fit-content" },
          mobile: { display: "flex", flexDirection: "row", width: "90%", justifyContent: "space-between", height: "fit-content" },
        })}>
            <div style={reValue({
              desktop: { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-start", height: "fit-content", width: "fit-content" },
              tablet: { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-start", height: "fit-content", width: "fit-content" },
              mobile: { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-start", height: "fit-content", width: "fit-content" },
            })}>
                <div style={reValue({
                  desktop: { fontWeight: "bold", fontSize: "28px", margin: "0px 0px 40px 0px" },
                  tablet: { fontWeight: "bold", fontSize: "28px", margin: "0px 0px 40px 0px" },
                  mobile: { fontWeight: "bold", fontSize: "28px", margin: "0px 0px 40px 0px" },
                })}>
                    SMP Stories
                </div>
            </div>
            <div style={reValue({
              desktop: { display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItms: 'center', fontSize: '30px', margin: '0px 5px 0px 0px' },
              tablet: { display: 'none', flexDirection: 'row', justifyContent: 'center', alignItms: 'center', fontSize: '30px', margin: '0px 5px 0px 0px' },
              mobile: { display: 'none', flexDirection: 'row', justifyContent: 'center', alignItms: 'center', fontSize: '30px', margin: '0px 5px 0px 0px' },
            })}>
                <BiChevronLeftCircle onClick={scrollLeft} style={styles.icon} />
                <div style={{ width: '15px' }}></div>
                <BiChevronRightCircle onClick={scrollRight} style={styles.icon} />
            </div>
        </div>
        <div style={reValue({
            desktop: { 
                width: "90%",
                position: "relative", 
                display: "flex",
            },
            tablet: { 
                width: "80%",
                position: "relative", 
                display: "flex",
            },
            mobile: { 
                width: "90%",
                position: "relative", 
                display: "flex",
            },
        })}>
        <div ref={scrollRef} style={reValue({
            desktop: { 
                width: '100%', 
                overflowX: 'auto', 
                whiteSpace: 'nowrap', 
                scrollbarWidth: 'none' 
            },
            tablet: { 
                width: '100%', 
                overflowX: 'auto', 
                whiteSpace: 'nowrap', 
                scrollbarWidth: 'none' 
            },
            mobile: { 
                width: '100%', 
                overflowX: 'auto', 
                whiteSpace: 'nowrap', 
                scrollbarWidth: 'none' 
            },
        })}>
            {cards.map((card, index) => (
                <div 
                    key={index} 
                    style={reValue({
                        desktop: {
                          backgroundColor: '#fff',
                            borderRadius: '8px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            display: 'inline-block',
                            flexDirection: 'column',
                            height: '400px',
                            width: '220px',
                            justifyContent: 'flex-start',
                            maxWidth: '300px',
                            margin: '0px 38px 0px 0px',
                            position: 'relative',
                            overflow: 'hidden',
                            cursor: 'pointer'
                        },
                        tablet: {
                            backgroundColor: '#fff',
                            borderRadius: '8px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            display: 'inline-block',
                            flexDirection: 'column',
                            height: '540px',
                            width: 'auto',
                            justifyContent: 'flex-start',
                            maxWidth: '300px',
                            margin: '0px 28px 0px 0px',
                            position: 'relative',
                            overflow: 'hidden',
                            cursor: 'pointer'
                        },
                        mobile: {
                            backgroundColor: '#fff',
                            borderRadius: '8px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            display: 'inline-block',
                            flexDirection: 'column',
                            height: '80vw',
                            width: 'auto',
                            justifyContent: 'flex-start',
                            maxWidth: '48.5%',
                            margin: '0px 10px 0px 0px',
                            position: 'relative',
                            overflow: 'hidden',
                            cursor: 'pointer'
                        }
                    })}
                    // onMouseEnter={() => setHoveredCard(index)}
                    // onMouseLeave={() => setHoveredCard(null)}
                    onClick={ () => showTheOverlay(card.videoId)}
                >
                    <img 
                        width="100%" 
                        height="100%"
                        src={`https://img.youtube.com/vi/${card.videoId}/0.jpg`}
                        alt={`Thumbnail for ${index}`}
                        style={{
                            objectFit: 'cover',
                            padding: '0',
                            margin: '0',
                            borderRadius: '8px',
                        }}
                    />
                    <div 
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: hoveredCard === index ? 'rgba(0, 0, 0, 0.4)' : 'rgba(0, 0, 0, 0)',
                            transition: 'background-color 0.3s ease-in-out',
                            borderRadius: '8px',
                        }}
                    />
                </div>
            ))}
        </div>

            {
                reValue({
                    desktop: <button style={{
                        'position': 'absolute',
                        'top': '50%',
                        'transform': 'translateY(-50%)',
                        'backgroundColor': 'rgba(0, 0, 0, 0.2)',
                        'color': 'white',
                        'border': 'none',
                        'padding': '10px 10px 10px 5px',
                        'borderRadius': '50%',
                        'width': '40px',
                        'height': '80px',
                        'borderRadius': '0px 45px 45px 0',
                        'cursor': 'pointer',
                        'zIndex': '1',
                        'display': 'none',
                        'alignItems': 'center',
                        'justifyContent': 'center',
                        'left': '0px',
                    }} onClick={() => scrollLeft()}> <FaChevronLeft size={25} />
                    </button>,
                    tablet: <button style={{
                        'position': 'absolute',
                        'top': '50%',
                        'transform': 'translateY(-50%)',
                        'backgroundColor': 'rgba(0, 0, 0, 0.2)',
                        'color': 'white',
                        'border': 'none',
                        'padding': '10px 10px 10px 5px',
                        'borderRadius': '50%',
                        'width': '40px',
                        'height': '80px',
                        'borderRadius': '0px 45px 45px 0',
                        'cursor': 'pointer',
                        'zIndex': '1',
                        'display': 'flex',
                        'alignItems': 'center',
                        'justifyContent': 'center',
                        'left': '0px',
                    }} onClick={() => scrollLeft()}> <FaChevronLeft size={25} />
                    </button>,
                    mobile: <button style={{
                        'position': 'absolute',
                        'top': '50%',
                        'transform': 'translateY(-50%)',
                        'backgroundColor': 'rgba(0, 0, 0, 0.2)',
                        'color': 'white',
                        'border': 'none',
                        'padding': '10px 10px 10px 5px',
                        'borderRadius': '50%',
                        'width': '40px',
                        'height': '80px',
                        'borderRadius': '0px 45px 45px 0',
                        'cursor': 'pointer',
                        'zIndex': '1',
                        'display': 'flex',
                        'alignItems': 'center',
                        'justifyContent': 'center',
                        'left': '0px',
                    }} onClick={() => scrollLeft()}> <FaChevronLeft size={25} />
                    </button>
                })
            }

            {
                reValue({
                    desktop: <button style={{
                        'position': 'absolute',
                        'top': '50%',
                        'transform': 'translateY(-50%)',
                        'backgroundColor': 'rgba(0, 0, 0, 0.2)',
                        'color': 'white',
                        'border': 'none',
                        'padding': '10px 5px 10px 10px',
                        'borderRadius': '50%',
                        'width': '40px',
                        'height': '80px',
                        'borderRadius': '45px 0 0 45px',
                        'cursor': 'pointer',
                        'zIndex': '1',
                        'display': 'none',
                        'alignItems': 'center',
                        'justifyContent': 'center',
                        'right': '0px',
                    }} onClick={() => scrollRight()}>
                    <FaChevronRight size={25} />
                    </button>,
                    tablet: <button style={{
                        'position': 'absolute',
                        'top': '50%',
                        'transform': 'translateY(-50%)',
                        'backgroundColor': 'rgba(0, 0, 0, 0.2)',
                        'color': 'white',
                        'border': 'none',
                        'padding': '10px 5px 10px 10px',
                        'borderRadius': '50%',
                        'width': '40px',
                        'height': '80px',
                        'borderRadius': '45px 0 0 45px',
                        'cursor': 'pointer',
                        'zIndex': '1',
                        'display': 'flex',
                        'alignItems': 'center',
                        'justifyContent': 'center',
                        'right': '0px',
                    }} onClick={() => scrollRight()}>
                    <FaChevronRight size={25} />
                    </button>,
                    mobile: <button style={{
                        'position': 'absolute',
                        'top': '50%',
                        'transform': 'translateY(-50%)',
                        'backgroundColor': 'rgba(0, 0, 0, 0.2)',
                        'color': 'white',
                        'border': 'none',
                        'padding': '10px 5px 10px 10px',
                        'borderRadius': '50%',
                        'width': '40px',
                        'height': '80px',
                        'borderRadius': '45px 0 0 45px',
                        'cursor': 'pointer',
                        'zIndex': '1',
                        'display': 'flex',
                        'alignItems': 'center',
                        'justifyContent': 'center',
                        'right': '0px',
                    }} onClick={() => scrollRight()}>
                    <FaChevronRight size={25} />
                    </button>
                })
            }

        </div>
      </div>
    );
  }

export default Highlights;
